import { Link } from "react-router-dom";
import logo from "../assets/Logo1.png";

const quickLinks = [
  ["Home", "/"],
  ["About Us", "/about"],
  ["FAQ", "/faq"],
  ["Contact", "/contact"],
];

const legalLinks = [
  ["Privacy Policy", "/privacy"],
  ["Terms & Conditions", "/termsconditions"],
  ["Driver Privacy Policy", "/driver-privacy"],
];

const socialLinks = [
  ["facebook-f", "https://www.facebook.com/share/1D39BHwkeB/", "Facebook"],
  ["twitter", "https://x.com/Trogodrafts", "X"],
  [
    "instagram",
    "https://www.instagram.com/trogodrafts?igsh=b2Vnb2lyZ2Q5NHlm",
    "Instagram",
  ],
];

export default function Footer() {
  return (
    <footer className="bg-[#101820] text-slate-300">
      <div className="border-y border-white/10 bg-white/[0.03]">
        {/* <div className="mx-auto flex max-w-7xl flex-col gap-5 px-6 py-6 md:flex-row md:items-center md:justify-between"> */}
          {/* <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-trogoOrange">
              TROGO Mobility
            </p>
            <h2 className="mt-2 text-2xl font-bold text-white">
              Ready for passenger rides and goods transport.
            </h2>
          </div> */}
          {/* <div className="flex flex-col gap-3 sm:flex-row">
            {appLinks.map(([title, subtitle, path, icon], index) => (
              <a
                key={title}
                href={path}
                download
                className={`group inline-flex min-w-[215px] items-center gap-3 rounded-lg px-4 py-3 text-left transition ${
                  index === 0
                    ? "bg-trogoOrange text-white hover:bg-[#e64f30]"
                    : "border border-white/15 bg-white/[0.04] text-white hover:border-trogoOrange hover:bg-white/[0.08]"
                }`}
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-white/15">
                  <i className={icon} />
                </span>
                <span>
                  <span className="block text-sm font-semibold">{title}</span>
                  <span className="block text-xs text-white/70">{subtitle}</span>
                </span>
              </a>
            ))}
          </div> */}
        {/* </div> */}
      </div>

      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.35fr_0.7fr_0.95fr_1.2fr]">
          <div>
            <Link to="/" className="inline-flex items-center gap-3">
              <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-white p-2">
                <img src={logo} alt="TROGO Logo" className="h-10 w-auto" />
              </span>
              <span>
                <span className="block text-xl font-bold tracking-wide text-white">
                  TROGO
                </span>
                <span className="block text-xs font-medium uppercase tracking-[0.22em] text-slate-500">
                  ToGoods Draft
                </span>
              </span>
            </Link>

            <p className="mt-5 max-w-sm text-sm leading-7 text-slate-400">
              A dependable transport platform for daily rides, goods movement,
              heavy vehicle requirements, and responsive service support.
            </p>

            <div className="mt-6 flex gap-3">
              {socialLinks.map(([icon, url, label]) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 bg-white/[0.04] text-slate-300 transition hover:border-trogoOrange hover:bg-trogoOrange hover:text-white"
                >
                  <i className={`fab fa-${icon}`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.22em] text-white">
              Company
            </h3>
            <nav className="mt-5 flex flex-col gap-3 text-sm">
              {quickLinks.map(([label, path]) => (
                <Link
                  key={path}
                  to={path}
                  className="text-slate-400 transition hover:text-trogoOrange"
                >
                  {label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.22em] text-white">
              Policies
            </h3>
            <nav className="mt-5 flex flex-col gap-3 text-sm">
              {legalLinks.map(([label, path]) => (
                <Link
                  key={path}
                  to={path}
                  className="text-slate-400 transition hover:text-trogoOrange"
                >
                  {label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.22em] text-white">
              Contact
            </h3>
            <div className="mt-5 grid gap-4 text-sm text-slate-400">
              <p className="flex gap-3 leading-6">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-trogoOrange/10 text-trogoOrange">
                  <i className="fa-solid fa-location-dot" />
                </span>
                <span>
                  Darhane Tal Baglan Nashik, Munjwad, Satana, Nashik - 423301
                </span>
              </p>
              <a
                href="mailto:info@togoodsdraft.com"
                className="flex items-center gap-3 transition hover:text-trogoOrange"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-trogoOrange/10 text-trogoOrange">
                  <i className="fa-solid fa-envelope" />
                </span>
                info@togoodsdraft.com
              </a>
              <a
                href="tel:+919552396672"
                className="flex items-center gap-3 transition hover:text-trogoOrange"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-trogoOrange/10 text-trogoOrange">
                  <i className="fa-solid fa-phone" />
                </span>
                +91 9552396672
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-5 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>
            &copy; {new Date().getFullYear()} ToGoods Draft Private Limited.
            All Rights Reserved.
          </p>
          <p>Built for passenger, goods, and transport partner mobility.</p>
        </div>
      </div>
    </footer>
  );
}
